"use strict";
export const headerStyles = (name, tableHovered) => {
  switch (name) {
    case "id":
      return { minWidth: "80px" };
    case "name":
      return { minWidth: "200px" };
    case "emails":
      return { minWidth: "200px" };
    case "status":
      return { minWidth: "120px" };
    default:
      return { minWidth: "100px" };
  }
};
